import React, { FC } from "react"

const EyeOnIcon: FC = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none">
      <path
        d="M1 12.002C1 12.002 5 4.00195 12 4.00195C19 4.00195 23 12.002 23 12.002C23 12.002 19 20.002 12 20.002C5 20.002 1 12.002 1 12.002Z"
        stroke="#2F3B5A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15.002C13.6569 15.002 15 13.6588 15 12.002C15 10.3451 13.6569 9.00195 12 9.00195C10.3431 9.00195 9 10.3451 9 12.002C9 13.6588 10.3431 15.002 12 15.002Z"
        stroke="#2F3B5A"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default EyeOnIcon
